module.exports = __webpack_public_path__ + "nh-white-ab73c8b80175119b161f.svg";